import baseUrl from "../config/baseUrl";

// Document Audit Trail (read-only, built from existing document / request /
// OCR data on the server).

const get = async (path, token, params) => {
  try {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""))
    ).toString();
    const response = await fetch(`${baseUrl}/api/${path}?${qs}`, {
      method: "GET",
      headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
    });
    return await response.json();
  } catch (error) {
    return { status: "failed", error: error?.message || "Network error" };
  }
};

export const getAuditTrail = ({ token, range, documentType, search, isAdmin, userId, roleId }) =>
  get("audit-trail", token, { range, document_type: documentType, search, isAdmin, userId, roleId });

export const getDocumentAuditTrail = ({ token, documentId, isAdmin, userId, roleId }) =>
  get("audit-trail-document", token, { document_id: documentId, isAdmin, userId, roleId });
